import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Spa from './barba/Spa';
import ScrollLocking from './components/Scrolllocking';
import AutoplayVideos from './components/AutoplayVideos';
import Header from './components/Header';
import WorkSwitcher from './components/WorkSwitcher';
import Cursors from './components/Cursors';

export class MLF {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([MLF.domReady()]).then(() => this.init());
	}

	init() {
		new Spa();
		new ScrollLocking();
		new AutoplayVideos();

		this.headerElm = document.querySelector('[data-header]');
		if(this.headerElm) {
			new Header(this.headerElm);
		}

		this.workSwitcherElm = document.querySelector('[data-work-switcher]');
		if(this.workSwitcherElm) {
			new WorkSwitcher(this.workSwitcherElm);
		}

		this.cursors = document.querySelector('[data-cursors]');
		if(this.cursors) {
			new Cursors(this.cursors);
		}

	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new MLF();